import creditEngineRepository, { CreditEngineRepository } from './CreditEngineRepository'

const resource = "/attribute";
export default {
  createOrUpdateAttribute(attributeDto) {
    creditEngineRepository.setContentType("application/json");
    return CreditEngineRepository.put(`${resource}`, attributeDto);
  },

  getAttributes(entityType, entityId) {
    creditEngineRepository.setContentType("application/json");
    return CreditEngineRepository.get(`${resource}/${entityType}/${entityId}`);
  }
}
